export * from './navigation'
export * from './routing'
export * from './request'

export const slugParams = async (params: Promise<{ locale: string; slug: string }>) => {
  const { locale, slug } = await params
  return { locale, slug: `${locale}-${slug}` }
}
